import { inject, Service } from '@angular/core';
import { Store } from '@ngxs/store';
import { LexplusPermissionsEnum } from '@lexplus-authentication-api';
import { ProfileState } from '../states/profile/profile-state';

@Service()
export class PermissionsService {
  private readonly store = inject(Store);

  public hasPermissions(permissionString: LexplusPermissionsEnum): boolean {
    return this.store.selectSnapshot(ProfileState.hasPermission(permissionString));
  }

  /**
   * Whether the user receives the newsletter. Not a permission: a subscriber without any right
   * still reaches their own newsletters.
   *
   * @returns {boolean} True for a subscriber.
   */
  public isNewsletterSubscriber(): boolean {
    return this.store.selectSnapshot(ProfileState.isNewsletterSubscriber);
  }
}
